export default __webpack_public_path__ + "static/media/icon-navigation-notes-to-crew.ba8e4cde.svg";